export const validationTypes = {
  SPECIAL_CHAR: 'special-char',
  LENGTH: 'length'
};

export default class NotificationState {
  id = Number;
  message = String;
  type = String;
  validationType = String;
  dismissable = Boolean;

  initialize() {
    let i = this;
    i = i.validationType.state === validationTypes.LENGTH
      ? i.dismissable.set(false)
      : i.dismissable.set(true);
    return i;
  }
}
